module.exports = __webpack_public_path__ + "static/Resume2021-37e2a032a2de07ef4edd7354785b3047.pdf";